<template>
    <b-modal
        :title="$t('history.modal.header.ChangeTrackingLink')"
        ref="tracking-modal"
        @ok="updateTrackingLink"
    >
        <form ref="form">
            <b-form-group :label="$t('history.modal.body.TrackingLink')">
                <b-form-input
                    v-model="trackingLink"
                    required
                    name="trackingLinkModalInput"
                ></b-form-input>
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">
                Cancel
            </b-button>
            <b-button @click="ok()" name="changeTrackingModalButton" variant="primary">
                {{ $t('history.modal.button.Change') }}
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
import helpers from '@/helper';

export default {
    props: {
        shipment: { type: Object, required: true }
    },

    data() {
        return {
            trackingLink: ''
        };
    },

    methods: {
        showTrackingModal() {
            const cloneShipment = helpers.cloneObject(this.shipment);
            this.trackingLink = cloneShipment.trackingLink;

            this.$refs['tracking-modal'].show();
        },

        updateTrackingLink() {
            this.shipment.trackingLink = this.trackingLink;

            this.$store.dispatch(
                HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_TRACKING_LINK,
                this.shipment
            );
        }
    }
};
</script>

<style></style>
